import React from "react";
import { AlertTriangle } from "lucide-react";
import useSyncHealth, { relTime, fmtDT } from "@/lib/useSyncHealth";

/**
 * Globale waarschuwing wanneer de Mondo (Supabase) synchronisatie achterloopt
 * of een fout had. Verschijnt bovenaan elke pagina — verdwijnt automatisch
 * zodra de sync weer gezond is.
 */
export default function SyncHealthBanner() {
  const { health } = useSyncHealth();
  if (!health) return null;
  const isError = health.last_status === "error";
  if (!health.stale && !isError) return null;

  const cls = isError
    ? "bg-[#FBE7E7] border-[#EFBABA] text-[#7B2424]"
    : "bg-[#FDF3DF] border-[#EAD49B] text-[#5A3F0B]";
  return (
    <div
      className={`shrink-0 flex items-center gap-2.5 px-5 py-2 border-b text-[12px] ${cls}`}
      data-testid="sync-health-banner"
      data-sync-state={isError ? "error" : "stale"}
    >
      <AlertTriangle size={14} className="shrink-0" />
      <span className="min-w-0 truncate">
        {isError ? (
          <>
            <strong>Synchronisatie-fout</strong> — {health.last_error || "laatste sync is mislukt"}.{" "}
          </>
        ) : (
          <>
            <strong>Synchronisatie loopt achter</strong> — pandstatussen (online/offline) kunnen verouderd zijn.{" "}
          </>
        )}
        Laatste geslaagde sync:{" "}
        <strong title={fmtDT(health.last_success_at)}>{relTime(health.last_success_at)}</strong>
      </span>
    </div>
  );
}
